var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#59A3CF",
    d: "M43.7,344.4c18.8,0,33.7-15.2,33.7-34V147.2c0-37.5,31.8-68.2,69.3-68.2h163.2c18.8,0,34-15.5,34-34.2s-15.2-34.2-34-34.2H146.6C71.6,10.5,10,72.2,10,147.2v163.2C10,329.2,24.9,344.4,43.7,344.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59A3CF",
    d: "M854,10.5H690.7c-18.8,0-34,15.5-34,34.2c0,18.8,15.2,34.2,34,34.2H854c37.5,0,66.5,30.7,66.5,68.2v163.2c0,18.8,15.5,34,34.2,34s34.2-15.2,34.2-34V147.2C989,72.2,929,10.5,854,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59A3CF",
    d: "M954.7,657.3c-18.8,0-34.2,15.2-34.2,34v163.2c0,37.5-29,66.5-66.5,66.5H690.7c-18.8,0-34,15.5-34,34.2s15.2,34.2,34,34.2H854c75,0,135-59.9,135-134.9V691.3C989,672.5,973.5,657.3,954.7,657.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59A3CF",
    d: "M309.9,921H146.6c-37.5,0-69.3-29-69.3-66.5V691.3c0-18.8-14.9-34-33.7-34c-18.8,0-33.7,15.2-33.7,34v163.2c0,75,61.6,134.9,136.6,134.9h163.2c18.8,0,34-15.5,34-34.2S328.7,921,309.9,921z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59A3CF",
    d: "M956,464.1H44.6c-18.8,0-34,14.9-34,33.7c0,18.8,15.2,33.7,34,33.7H956c18.8,0,34-14.9,34-33.7C990,479,974.8,464.1,956,464.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanActive);
export default __webpack_public_path__ + "static/media/scan-active.037e30b080526bb8503ca2d49193f8ed.svg";
export { ForwardRef as ReactComponent };